"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
/**
 * Local Imports
 */

const Switch = /*#__PURE__*/(0, _react2.styled)("input")({
  name: "Switch",
  class: "pl-sld06ot"
});
const Label = /*#__PURE__*/(0, _react2.styled)("label")({
  name: "Label",
  class: "pl-l1av86wt"
});

/**
 * GroupToggleItem Component.
 * @module GroupToggleItem
 *
 * @param {Object} props React props
 * @param {String} props.id Content item id
 * @param {String} props._name Content item name
 * @param {String} props.value Radio button value
 * @param {Boolean} props.isSelected Button 'Setted' Label
 * @param {Function} props.onChange Buttons Active Status 'onChange' function
 * @param {String} props.groupName Button Group Name
 * @param {String} props.groupDescription Button Group Description
 * @returns {React.ReactElement} GroupToggleItem Component
 * @public
 */

function GroupToggleItem({
  id,
  name = 'group',
  _name,
  value,
  isSelected,
  onChange,
  groupName,
  groupDescription,
  dataCy
}) {
  if (!onChange) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Switch, {
    id: `id-${id}`,
    onChange: onChange,
    value: value,
    type: "radio",
    "data-selected": isSelected,
    checked: isSelected,
    name: name
  }), /*#__PURE__*/_react.default.createElement(Label, (0, _extends2.default)({
    htmlFor: `id-${id}`
  }, _patternLibraryUtils.tracking.create(_name, true, false), {
    "data-cy": dataCy
  }), /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "title",
    size: 2,
    text: groupName
  }), /*#__PURE__*/_react.default.createElement(_text.default.span, {
    as: "paragraph",
    text: groupDescription
  })));
}
var _default = exports.default = GroupToggleItem;
GroupToggleItem.propTypes = {
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  _name: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  isSelected: _propTypes.default.bool,
  groupName: _propTypes.default.string,
  groupDescription: _propTypes.default.string,
  onChange: _propTypes.default.func,
  dataCy: _propTypes.default.string
};